"use strict";
exports.__esModule = true;
exports.AccountLevel = void 0;
var AccountLevel;
(function (AccountLevel) {
    AccountLevel["ParentAccount"] = "PARENT_ACCOUNT";
    AccountLevel["SubAccount"] = "SUB_ACCOUNT";
})(AccountLevel = exports.AccountLevel || (exports.AccountLevel = {}));
